<div class="display form-control"></div>
<div class="menu hide">
  <div class="level-1"></div>
  <div class="level-2"></div>
</div>
